import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MenuItem, MenuItemCommandEvent } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import { LoggedInUserService } from 'src/app/services/auth/logged-in-user-service';
import { PycnometerProfilesPageComponent } from 'src/app/pages/pycnometer-profiles/pycnometer-profiles-page.component';
import { WellsPageComponent } from 'src/app/pages/wells/wells-page.component';
import { RigsPageComponent } from 'src/app/pages/rigs/rigs-page.component';
import { BusinessUnitsPageComponent } from 'src/app/pages/business-units/business-units-page.component';
import { AssetClassesPageComponent } from 'src/app/pages/asset-classes/asset-classes-page.component';
import { ChartsPageComponent } from 'src/app/pages/charts/charts-page.component';
import { SystemDefaultsModalComponent } from 'src/app/pages/tools/system-defaults-modal/system-defaults-modal.component';
import { ProjectsService } from 'src/app/services/projects.service';

interface User {
  roles: string[];
}

@Component({
    selector: 'app-cvx-navbar',
    imports: [CommonModule, MenubarModule, RouterModule, MatDialogModule],
    templateUrl: './cvx-navbar.component.html',
    styleUrl: './cvx-navbar.component.scss'
})
export class CvxNavbarComponent {  
  private loggedInUserService = inject(LoggedInUserService);
  private readonly dialog = inject(MatDialog);
  private router = inject(Router);
  private projectsService = inject(ProjectsService);

  protected navbarMenuItems = signal<MenuItem[] | undefined>([
    { "label": "Home", "command": () => { this.projectsService.setAsideExpanded(true); this.projectsService.triggerReset(); this.router.navigate(['/jobs'], { queryParams: { year: new Date().getFullYear() } }); } },
    { "label": "Samples", "link": "/sample" },
    { "label": "Materials", "link": "materials" },
    { "label": "Operations Dashboard", "command": () => { this.projectsService.setAsideExpanded(false); this.router.navigate(['/operational-dashboard']); } },
    {
      "label": "Tools",
      "items": [
        {
          "label": "System Defaults",
          "command": () => this.openSystemDefaultsModal()
        },
        {
          "label": "Metrics",
          "command": () => this.router.navigate(['/tools/metrics'])
        },
        {
          "label": "Job Request Search",
          "command": () => this.router.navigate(['/tools/job-request-search'])
        },
        {
          "label": "Pycnometer Profiles",
          "command": () => this.openPycnometerProfilesModal()
        },
        {
          "label": "Materials Search",
          "command": () => this.router.navigate(['/tools/sample-manager-search'])
        },
        {
          "label": "Dynamic Forms",
          "command": () => this.router.navigate(['/tools/custom-test-definitions'])
        },
        {
          "label": "Rigs",
          "command": () => this.openRigsModal()
        },
        {
          "label": "Wells",
          "command": () => this.openWellsModal()
        },
        {
          "label": "Business Units",
          "command": () => this.openBusinessUnitsModal()
        },
        {
          "label": "Asset Classes",
          "command": () => this.openAssetClassesModal()
        },
        {
          "label": "Charts",
          "command": () => this.openChartsModal()
        }
      ]
    }
  ]);

  constructor() {
    this.loggedInUserService.currentUser$.subscribe((data: User) => {
      if (data && data.roles) {
        
      }
    });
  }

  ngOninit() { }

  protected runMenuCommand(item: MenuItem): void {
    if (item.command) {
      item.command({} as MenuItemCommandEvent);
    }
  }

  private openPycnometerProfilesModal(): void {
    this.dialog.open(PycnometerProfilesPageComponent, {
      width: '1100px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      autoFocus: false,
      panelClass: 'pycnometer-profiles-modal'
    });
  }

  private openRigsModal(): void {
    this.dialog.open(RigsPageComponent, {
      width: '1400px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      autoFocus: false,
      panelClass: 'rigs-modal'
    });
  }

  private openWellsModal(): void {
    this.dialog.open(WellsPageComponent, {
      width: '1400px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      autoFocus: false,
      panelClass: 'wells-modal'
    });
  }

  private openBusinessUnitsModal(): void {
    this.dialog.open(BusinessUnitsPageComponent, {
      width: '1100px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      autoFocus: false,
      panelClass: 'business-units-modal'
    });
  }

  private openAssetClassesModal(): void {
    this.dialog.open(AssetClassesPageComponent, {
      width: '1100px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      autoFocus: false,
      panelClass: 'asset-classes-modal'
    });
  }

  private openSystemDefaultsModal(): void {
    this.dialog.open(SystemDefaultsModalComponent, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      autoFocus: false,
      panelClass: 'system-defaults-modal'
    });
  }

  private openChartsModal(): void {
    this.dialog.open(ChartsPageComponent, {
      width: '1100px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      autoFocus: false,
      panelClass: 'charts-modal'
    });
  }
}
